import { getAuthenticatedSupabaseClient } from '@/integrations/supabase/client';
import { Room } from '@/types/floorPlanViewer';

export const roomServiceAdapter = {
  async getByFloorPlan(floorPlanId: string): Promise<Room[]> {
    const supabase = await getAuthenticatedSupabaseClient();
    const { data, error } = await supabase
      .from('rooms')
      .select('*')
      .eq('floor_plan_id', floorPlanId)
      .order('created_at', { ascending: true });

    if (error) throw error;
    return (data || []) as any;
  },

  async create(item: Partial<Room>): Promise<Room> {
    const supabase = await getAuthenticatedSupabaseClient();
    const { data, error } = await supabase
      .from('rooms')
      .insert(item as any)
      .select()
      .single();

    if (error) throw error;
    return data as any;
  },

  async update(id: string, updates: Partial<Room>): Promise<Room> {
    const supabase = await getAuthenticatedSupabaseClient();
    const { data, error } = await supabase
      .from('rooms')
      .update(updates as any)
      .eq('id', id)
      .select()
      .single();

    if (error) throw error;
    return data as any;
  },

  async delete(id: string): Promise<boolean> {
    const supabase = await getAuthenticatedSupabaseClient();
    const { error } = await supabase
      .from('rooms')
      .delete()
      .eq('id', id);

    if (error) throw error;
    return true;
  },
}; 
